export default "__VITE_ASSET__Bi09J680__"